import { cx } from '@7f-ui'
import { createGermanNumberFormatter } from '@utils/utils-format'
import { shopTestId } from '@utils/utils-shop-test-ids'

import { Price } from './price'

type PriceWithDiscountProps = {
  name?: string | null
  discount?: number | null
  type?: string | null
  value?: number | null
  totalAfterDiscount?: number | null
  currency: string
}

export function PriceWithDiscount({
  name,
  discount,
  value,
  type,
  totalAfterDiscount,
  currency,
}: PriceWithDiscountProps) {
  const formatDiscount = useFormatDiscount(currency)
  if (!name || !discount || !value || !type) return

  return (
    <div className="flex w-full items-center justify-between gap-2">
      <div
        data-testid={shopTestId('PromoCode.discountRowName')}
        className={cx('font-body-copy text-success', {
          'font-body-small': totalAfterDiscount,
        })}
      >
        {name} {`(${formatDiscount(type, value)})`}
      </div>
      <div
        className="flex items-center gap-2 font-body-copy"
        data-testid={shopTestId('PromoCode.discountRowPrice')}
      >
        <Price
          amount={discount * -1}
          currency={currency}
          className={cx('font-body-copy text-success', {
            'font-body-small': totalAfterDiscount,
          })}
        />
      </div>
    </div>
  )
}

export function useFormatDiscount(currency: string) {
  return (type?: string | null, value?: number | null) => {
    const currencyFormat = createGermanNumberFormatter({
      style: 'currency',
      currency,
    })
    const percentageFormat = createGermanNumberFormatter({
      style: 'percent',
    })

    if (type === 'percentage') {
      return percentageFormat.format((value || 0) / 10000)
    }
    if (type === 'amount') {
      return currencyFormat.format((value || 0) / 100)
    }
    return ''
  }
}
